
export default {
  props: {
    link: {
      type: String,
      required: true
    }
  },
  methods: {
    externalLink () {
      window.open(this.link, '_blank'); //to open in new tab
    }  
  }
}
